import { defineMessages } from 'utils/intl';

export default defineMessages({
  extendedPrice: '(Cena wraz z dodatkami)',
});
